import MypageQnAContainer from './MypageQnAContainer';
export default MypageQnAContainer;
